export default __webpack_public_path__ + "d6f4bb1cf1fbdd0e6951973dc5c0c4bd.png";